module.exports = "<span seedelement><slot></slot></span>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-flag/theme/lui-flag.html
// module id = 212
// module chunks = 0 1 33